import keyBy from 'lodash/keyBy';
import { arrayOf, bool, func, string } from 'prop-types';
import React from 'react';

import { PROJECT_VIEW } from '../constants';
import { ProvideCategories } from '../generic/CategorySelect';
import DocumentTitle from '../generic/DocumentTitle';
import Loading from '../generic/Loading';
import Titled from '../layout/Titled';
import ProjectQuoteEditor from '../project/ProjectQuote/ProjectQuoteEditor.container';
import { opportunityShape, productShape, quoteShape } from '../prop-types';
import { connectEditor } from './connect-editor';
import QuoteEditor from './QuoteEditor.container';
import normalizeQuote from './utils/normalize-quote';

const QuoteEditorDocumentTitle = connectEditor(({ quote }) => ({
  title: quote.name,
}))(DocumentTitle);

class UpdateQuote extends React.Component {
  componentDidMount() {
    const { opportunity, products, quote } = this.props;
    this.initializeEditor(quote, opportunity, products);
  }

  componentWillUnmount() {
    this.props.onClose();
  }

  initializeEditor(initialQuote, opportunity, products) {
    const { onInitialData } = this.props;

    const { quote, quoteLinesById } = normalizeQuote(initialQuote);
    const productsById = keyBy(products, 'id');

    onInitialData({ opportunity, productsById, quote, quoteLinesById });
  }

  render() {
    const { modified, initialized, view, isEditing, quote } = this.props;

    if (initialized) {
      return (
        <ProvideCategories>
          <QuoteEditorDocumentTitle />
          {view === PROJECT_VIEW ? (
            <ProjectQuoteEditor isQuoteDirty={modified} isEditing={isEditing} />
          ) : (
            <QuoteEditor
              isQuoteDirty={modified}
              initialQuote={normalizeQuote(quote)}
            />
          )}
        </ProvideCategories>
      );
    }

    return (
      <Titled title="Edit Quote">
        <Loading />
      </Titled>
    );
  }
}

UpdateQuote.propTypes = {
  onInitialData: func.isRequired,
  onClose: func.isRequired,
  initialized: bool.isRequired,
  modified: bool.isRequired,
  isEditing: bool,
  opportunity: opportunityShape.isRequired,
  products: arrayOf(productShape).isRequired,
  quote: quoteShape.isRequired,
  view: string.isRequired,
};

UpdateQuote.defaultProps = {
  isEditing: false,
};

export default UpdateQuote;
